<template>
    <div class="content">

        <toolbar v-bind:selection="toolbar" title="Editar tarea" />

        <v-form ref="form" v-model="valid" lazy-validation>

            <v-select
                    v-model="idcolmenar"
                    class="form-group"
                    color="orange"
                    :items="colmenares"
                    item-value="[id]"
                    item-text="[name]"
                    label="Colmenar*"
                    data-vv-name="idcolmenar"
                    v-on:change="onChange"
                    required
                    :rules="requiredRule"
            ></v-select>

            <v-select
                    v-model="infoform.idcolmena"
                    class="form-group"
                    color="orange"
                    :items="listColmenas"
                    item-value="[id]"
                    item-text="[number]"
                    label="Colmena*"
                    data-vv-name="infoform.idcolmena"
                    required
                    :rules="requiredRule"
            ></v-select>

            <p class="v-messages__message">{{errors.idcolmenar}}</p>



            <v-select
                    v-model="infoform.priority"
                    class="form-group"
                    color="orange"
                    :items="optionsPriority"
                    label="Prioridad"
                    data-vv-name="infoform.priority"
            ></v-select>

            <p><b>Descripción</b></p>
            <v-col class="col" cols="12" md="6">
                <v-textarea
                        solo
                        name="description"
                        label="Notas, comentarios..."
                        v-model="infoform.description"
                ></v-textarea>
            </v-col>

            <div class="row">
                <div class="col-d-10">
                    <b>Completar</b>
                </div>
                <div class="col-d-2">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.completed"
                            inset
                    ></v-switch>

                </div>

            </div>


            <loading v-bind:isloading="isloading" ></loading>

            <v-alert
                    dense
                    v-bind:type="alertForm"
                    text
                    :value="alert"
                    transition="scale-transition"
            >
                {{responseform}}
            </v-alert>


            <v-btn :disabled="!valid" class="mr-4 btn-yellow" @click="validate">
                Editar tarea
            </v-btn>

        </v-form>


    </div>


</template>

<script>
import auth from "@/libs/auth"


import toolbar from "@/components/Toolbar"
import loading from "@/components/Loader"

import axios from "axios";

export default {

    name: 'tarea-nueva',
    components: {
        toolbar,
        loading,
    },
    data() {
        return {

            toolbar: {
                return: '0'
            },

            valid: true,

            isloading:'',

            errors: {
                idcolmenar: '',
            },

            alertForm:'success',
            responseform:'',
            alert: false,

            optionsPriority: [
              { text: 'Baja', value: 'baja' },
              { text: 'Normal', value: 'normal' },
              { text: 'Alta', value: 'alta' },
              { text: 'Urgente', value: 'urgente' }
            ],

            listColmenas:[],

            idcolmenar:'',
            infoform: {
                idcolmena: '',
                priority: '',
                description: '',
                completed:''
            },

            info: null,
            colmenares: null,
            colmenar:null
  }},
  created() {
  auth.getUserLogged()
    this.getTodos();
  },
  methods:{

        async getTodos(){

            var that = this

           await axios.get("https://appws.panimiel.com/new/index.php/api/task/detail/"+this.$route.params.id).then((infoColmena) => {
              that.infoColmena = infoColmena.data
              that.idcolmenar = that.infoColmena.idcolmenar

              that.infoform.idcolmena = that.infoColmena.idcolmena
              that.infoform.priority = that.infoColmena.priority
              that.infoform.description = that.infoColmena.description
                if(that.infoColmena.completed === '1'){
                 that.infoform.completed = '1'
                }

              that.loadingcolmena = true

            })

             await axios.get("https://appws.panimiel.com/new/index.php/api/colmenar").then((colmenares) => {
              that.colmenares = colmenares.data
            })

            axios.get('https://appws.panimiel.com/new/index.php/api/colmena/'+this.idcolmenar+'/2/0')
            .then(function (response) {
              that.listColmenas = response.data;
            })

        },

        validate () {

            if(this.$refs.form.validate()){

                this.alert = false
                this.isloading = true

                this.errors.idcolmenar = ''

                axios.put('https://appws.panimiel.com/new/index.php/api/task/'+this.$route.params.id, this.infoform).then((response) => {
                    this.responseform = response.data
                     this.alertForm = 'success'
                     this.isloading=''
                     this.alert = true
                })
                .catch((error) => {
                    this.alertForm = 'error',
                    this.isloading=''

                    if (error.response.status != 500){
                        this.responseform = error.response.data
                    }else{
                        this.responseform = 'Error, no ha sido posible editar la tarea.'
                    }
                     this.alert = true

                 })

            }

        },
        onChange: function (){
            var self = this
           axios.get('https://appws.panimiel.com/new/index.php/api/colmena/'+this.infoform.idcolmenar)
            .then(function (response) {
              self.listColmenas = response.data;

              if(self.listColmenas.length < 1){
                self.infoform.idcolmena = ''
                self.errors.idcolmenar = "No hay colmenas para el colmenar seleccionado."
              }else{
                self.errors.idcolmenar = ""
              }
            })
         }
    }


};


</script>

<style scoped lang="scss">
</style>